'use client'

import { message } from 'antd'
import { MessageInstance } from 'antd/es/message/interface'
import { ReactNode, createContext, useContext } from 'react'

interface MessageContextType {
  messageApi: MessageInstance
}

const MessageContext = createContext<MessageContextType | null>(null)

export const useMessage = (): MessageInstance => {
  const context = useContext(MessageContext)
  if (!context) {
    throw new Error('useMessage must be used within MessageProvider')
  }
  return context.messageApi
}

export default function MessageProvider({ children }: { children: ReactNode }) {
  const [messageApi, contextHolder] = message.useMessage()

  return (
    <MessageContext.Provider value={{ messageApi }}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  )
}
